<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>
          
          <action-button @click="_new" icon="new" bold :text="lang.button_New"
            :tooltip="lang.button_New" :disabled="newButtonStatus" />
          <action-button @click="details" icon="details-part" bold :text="lang.button_Details"
            :tooltip="lang.button_Details" :disabled="detailsButtonStatus" />

          

        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>

      </action-bar>

      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TitleComponent from "@/components/shared/TitleComponent"
import Content from "@/components/RequestManager/Views/RequestTable/Middle/Content/Content"
//import * as Json2Svg from '@/Tools/json2svg';
import * as Tools from '@/Tools/Tools'

export default {
  name: 'Middle',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      newButtonStatus: false,
      detailsButtonStatus: true,
      deleteButtonStatus: true,
      
      toggleButtonStatus: false,
      fileCounter: 0,
      fileFeedback: [],
    }
  },
  created(){
    
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      selectedRequestRows: 'selectedRequestRows',
      appConf: 'appConf',
      globalSettings: "globalSettings"
    }),
    
  },
  watch: {
    selectedRequestRows: function (new_isData, old_isData) {
      //for details button
      if (this.selectedRequestRows.length == 1){
        this.detailsButtonStatus = false

      }else{
         this.detailsButtonStatus = true
      }
      
      //for delete button
      if (this.selectedRequestRows.length > 0){
        this.deleteButtonStatus = false

      }else{
         this.deleteButtonStatus = true
      }
      //for removeRevision button
      
      

    },
    
  },
  methods: {
    importFile(requestId){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      let vue = this;
      
      let lei = vue.$store.getters.requestCreateForm.file.length;
      


      const obj = {
        requestId: requestId,
        file: vue.$store.getters.requestCreateForm.file[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.$store.getters.requestCreateForm.file[vue.fileCounter].lastModified)
        
      }
      
      let fileName = vue.$store.getters.requestCreateForm.file[vue.fileCounter].name;
      
      vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importRequestFile", obj)
      .then(function(result){
        console.log(result);
        let obj2 = {};
        if (result.status == "OK"){
          
          obj2 = {
            result: "Added",
            fileName: fileName,            
            
          }
          
        }else{
          
          
          obj2 = {
            result: result.message,
            fileName: fileName,            
            
          }
          
          
        }
        vue.fileFeedback.push(obj2);
        
        
        vue.fileCounter++;
        
          if (vue.fileCounter > lei - 1){
            
            vue.$store.dispatch("showLoader", { visible: false, text: "" }); 

            let obj = {
              text: vue.lang.alert_success_CreateRequest + ". ",
              time: 10,
              type: "success"
            };

            vue.$store.dispatch("displayFooterAlert", obj);

            // const reloadObj = {
            //   status: true,
            //   name: "RequestDetailsComponent",
            //   source: ""
            // }
            // vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            if (vue.fileFeedback.length > 0) {

              let func = function () {
                vue.fileFeedback = [];
                vue.toDetails(requestId); 
              }

              
              const dataFiles = {
                fileImportResults: {},
                newRevisionId: null
              }
              for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

                const obj = {
                  result: vue.fileFeedback[i].result,
                            
                  
                }
                
                dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
              }
             
              vue.$store.dispatch("showLoader", {visible: false, text:""});
              vue.fileFeedback = [];

              const obj = {
                title: vue.lang.modal_title_PushLibrary,
                text: "",
                type: "push_files",
                buttons: 1,
                buttonName: "Close",
                // buttonWait: buttonWait,
                // commentWait: commentWait,
                size: "xl",
                lang: vue.lang.modal_PushRequest,
                funcNo: "",
                funcYes: "",
                funcCustom: func,
                data: dataFiles
              };
              
              vue.$store.dispatch("showModalComponent", obj);
            }
            
            
          }else{
            
            vue.importFile(requestId);
          }

      })
    },
    toDetails(requestId) {

      let to = "/RequestManager/RequestDetails";

      this.$store.dispatch("editPropertiesForm", false);

           
      
      let routingObject = {
        from: this.$route.path,
        to: to,
        requestId: requestId,
        sourceType: "table",
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }

      

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      this.$router.push({ path: to, query: routingObject }); 
    },
    details(){
      let to = "/RequestManager/RequestDetails";

      this.$store.dispatch("editPropertiesForm", false);

      let requestId = null;
      let partId = null;
      let partRevisionId = null;
      let id = 0;
      
      if (this.$store.getters.selectedRequestRows != undefined){
        requestId = this.$store.getters.selectedRequestRows[0].col___requestId.requestId;
        partId = this.$store.getters.selectedRequestRows[0].col___requestId.partId;
        partRevisionId = this.$store.getters.selectedRequestRows[0].col___requestId.partRevisionId;
      }

      let routingObject = {
        from: this.$route.path,
        to: to,
        requestId: requestId,
        //id: id,
        sourceType: "details",
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }

      if (partId != null) {
        routingObject.id = partId;
      }
      if (partRevisionId != null) {
        routingObject.revisionId = partRevisionId;
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      
      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: revisionId,
      //   id: id
      // }

      this.$router.push({ path: to, query: routingObject }); 
    },
    _new() {

      let vue = this;

      let funcYes = function () {
        
        let requestCreateForm = vue.$store.getters.requestCreateForm;
       
        let obj = {
          manufacturer: requestCreateForm.manufacturer,
          ManufacturerPartNumber: requestCreateForm.manufacturerPartNumber,
          remarks: requestCreateForm.remarks,
          deadLine: requestCreateForm.deadLine,
          priority: requestCreateForm.priority,
          type: requestCreateForm.type,
          libraryType: requestCreateForm.libraryType,

        }
        

        let action = null;
        if (requestCreateForm.type == "part") {
          action = "_createRequest";
        }
        if (requestCreateForm.type == "library") {
          action = "_createLibRequest";
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + action, obj)
          .then(function (result) {
            
            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {

                let requestId = null;
                if (requestCreateForm.type == "part") {
                  requestId = result.data;
                }
                if (requestCreateForm.type == "library") {
                  requestId = result.data.requestId;
                }
                
                if (vue.$store.getters.requestCreateForm.file.length > 0){
                  
                  
                  vue.fileCounter = 0;

                  
                  
                  vue.importFile(requestId);
                  
                } else {

                  let obj = {
                    text: vue.lang.alert_success_CreateRequest + ". ",
                    time: 10,
                    type: "success"
                  };

                  vue.$store.dispatch("displayFooterAlert", obj);
                  

                  // let reloadObj = {
                  //   status: true,
                  //   name: "RequestDetailsComponent",
                  //   source: ""
                  // }
                  // vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiRequestsComponent",
                    source: ""
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  vue.toDetails(requestId);
                }


                
              } else {
                let obj = {
                  text: vue.lang.alert_error_CreateRequest + ": " + result.message,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
                
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_CreateRequest + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
              
            }
          })
      }
      const obj = {
        title: "",
        text: "",
        type: "create_request",
        buttons: 2,
        buttonName: "Close",
        size: "lg",
        lang: vue.lang.modal_CreateRequest,
        funcNo: "",
        funcYes: funcYes,
        funcCustom: "",
        data: {}
      };
      vue.$store.dispatch("showModalComponent", obj);


      
    },
    
    
    
    
    
    
    goTo(){

            
      let to = "/RequestManager/RequestDetails";

      const obj = {
        col___requestId: {
          revisionId: this.lockedRevisionId.col___revisionId.revisionId,
          libraryId: this.lockedRevisionId.col___revisionId.libraryId
        },
        
        
      }
      

      this.$store.commit("SETREQUESTSELECTEDROWS", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      

      

      const query = {
        from: this.$route.path,
        to: to,
        pushed: true,
        revisionId: this.lockedRevisionId.col___revisionId.revisionId
      }

      this.$router.push({ path: to, query: query });
      
    },
    
    
    
    _delete(){
      
      let vue = this;

      let deleteLibraryFunc = function () {
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++) {
          selectedRows.push(vue.$store.getters.selectedRows[i].col___requestId.requestId);
        }

        const arr = {
          libraryIds: selectedRows
        }
        

        vue.$store.dispatch( vue.$store.getters.sectionPrefix + "_deleteRequest", arr)
        .then((result) =>{

          console.log(result)
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          let obj = {};
          if (result.status == "OK"){

            if (result.data != null) {

              let tab = [];
              for (let i = 0, lei = result.data.length; i < lei; i++) {

                if (result.data[i].success == false) {
                  tab.push(result.data[i]);
                }

              }
              if (tab.length > 0) {
                const objMod = {
                  title: vue.lang.modal_title_BulkFeedback,
                  text: "",
                  type: "bulk_feedback",
                  buttons: 1,
                  buttonName: vue.lang.modal_button_Close,
                  size: "xl",
                  lang: vue.lang.modal_BulkFeedback,
                  funcNo: "",
                  funcYes: "",
                  funcCustom: "",
                  data: { data: result.data }
                };
                vue.$store.dispatch("showModalComponent", objMod);
                
              } else {
                obj = {
                  text: vue.lang.alert_success_delete_library,
                  time: 10,
                  type: "success"
                }
                vue.$store.dispatch("displayFooterAlert", obj);
              }
                
              const reloadObj = {
                status: true,
                name: "DataTableFilteredOnApiLibComponent"
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              

            } else {
              

              obj = {
                text: vue.lang.alert_error_delete_library + ".",
                time: 15,
                type: "danger"
              }
              vue.$store.dispatch("displayFooterAlert", obj);
            }
          }else{
            obj = {
              text: vue.lang.alert_error_delete_library + ": " + result.message,
              time: 15,
              type: "danger"
            }
            vue.$store.dispatch("displayFooterAlert", obj);
          }
          
          
        })
      }

      const obj = {
        title: vue.lang.modal_title_delete,
        text: vue.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteLibraryFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    
    
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }


  },
  
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestTable/Middle/Middle.vue